module.exports = __webpack_public_path__ + "seal-box.9daa5c982f09a34c4c7f181c85f147ce.svg";